import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash/collection';
import TextField from 'components/TextField';
import { WrappedFieldProps } from 'redux-form';
import { Autocomplete } from '@material-ui/lab';

function FormAutocomplete({
  options,
  label,
  input: { onChange, value, onBlur },
  meta: { invalid, error, touched, warning },
  helperText,
  disabled,
  ...custom
}) {
  // const classes = useStyles();
  let helperMsg = helperText;
  if (warning) {
    helperMsg = warning;
  }
  if (touched && error) {
    helperMsg = error;
  }

  return (
    <Autocomplete
      disabled={disabled}
      options={options}
      value={find(options, opt => opt.value === value) || null}
      onChange={(e, newVal) => {
        onChange(newVal?.value || null);
        return onBlur(newVal?.value || null);
      }}
      getOptionLabel={option => option?.title || null}
      getOptionSelected={option => option?.value === value}
      renderOption={option => option.title}
      renderInput={params => (
        <TextField
          ref={params.InputProps.ref}
          variant="outlined"
          label={label}
          error={!!warning || (touched && invalid)}
          helperText={helperMsg}
          {...custom}
          InputProps={{
            ...params.InputProps,
            ...custom.InputProps,
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
            ...custom.InputLabelProps,
          }}
          /* eslint-disable react/jsx-no-duplicate-props */
          inputProps={{
            ...params.inputProps,
            // ...custom.InputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
}

FormAutocomplete.propTypes = {
  ...WrappedFieldProps,
  helperText: PropTypes.node,
  options: PropTypes.array,
};

export default FormAutocomplete;
